<template>
  <div class="leader-board">
    <!-- <h2 class="title mb-10">לוח נקודות</h2> -->
    <div class="loader" v-if="!user">
      <p style="margin: 40px;">
        {{ $t("leaderBoard.leaderBoard.register-only") }}
      </p>
      <LoginButton class="googleBtn" />
    </div>
    <div class="loader" v-if="user && !leaderboard">
      <!-- <div>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div> -->
      {{ $t("leaderBoard.leaderBoard.loading") }}
      <div
        style="text-align: center; display: flex; justify-content: center; margin: 8px;"
      >
        <SlinkyVue />
      </div>
    </div>
    <!-- <div class="loader" v-if="!showme">
      לא זמין
    </div> -->
    <div class="top-users" v-if="newList">
      <div
        class="user"
        v-for="(ruser, idx) in newList"
        :class="{ divMe: userProfileNum == ruser.id }"
        :key="idx"
      >
        <!-- <img
          v-if="user.photoURL"
          class="user-img"
          :src="user.photoURL"
          alt="תמונת משתמש"
        />
        <img
          v-if="!user.photoURL"
          class="user-img"
          :src="require('../../assets/svg/profile.svg').default"
          alt="תמונת משתמש"
        />
        <div class="displayName">{{ user.displayName }}</div> -->
        <!-- <div class="knows flex "> -->
        <div class="idx rankSqure">{{ ruser.num }}</div>
        <!-- <span class="laws">{{ countWords(user) }} מילים</span>
          <span class="words">{{ countLaws(user) }} חוקים </span> -->
        <div class="laws rankSqure">{{ ruser.words_score }}</div>
        <div class="words rankSqure">{{ ruser.rules_score / 5 }}</div>
        <div class="sentance rankSqure">{{ ruser.sentences_score / 10 }}</div>
        <!-- </div> -->
      </div>
      <!-- <div v-if="user.user_rank > 10" class="user divMe">
        <div class="idx rankSqure">{{ user.user_rank }}</div>

        <div class="laws rankSqure">{{ user.words_score }}</div>
        <div class="words rankSqure">{{ user.rules_score }}</div>
        <div class="sentance rankSqure">{{ user.sentences_score }}</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { userService } from "../../services/userService";
import GoogleButton from "../User/googleButton.vue";
import "./leaderBoard.scss";
import SlinkyVue from "../Shared/Slinky.vue";

export default {
  name: "leader-board",
  data() {
    return {
      showme: false,
      leaderboard: null,
      userProfile: null,
      newList: null
    };
  },
  async mounted() {
    //need loader
    console.log("created leader board");
    if (this.user) {
      this.leaderboard = await userService.getLeaderBoard();
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    userScore() {
      if (this.user) {
        return this.user.score;
      }
    },
    userProfileNum() {
      if (this.user) {
        return this.user.profile_id;
      }
    }
  },
  watch: {
    async user() {
      // this.userProfile = this.userId;
      this.leaderboard = await userService.getLeaderBoard();
    },
    leaderboard() {
      if (this.user) {
        const myScore = this.user.score;
        const myRank = this.user.user_rank;
        let a;
        const me = this.leaderboard.findIndex(
          res => res.id == this.userProfileNum
        );
        console.log("ME", me);
        // if (me !== -1) {
        //   if (me + 1 == this.user.user_rank) {
        //     console.log("same rank");
        //     a = this.leaderboard;
        //   } else {
        //     const myUser = this.leaderboard.find(
        //       res => res.id == this.userProfileNum
        //     );
        //     console.log(this.userProfileNum);
        //     a = this.leaderboard.filter(res => res.id !== this.userProfileNum);
        //     console.log(a);
        //     a.splice(this.user.user_rank - 1, 0, myUser);
        //     console.log(a);
        //     this.userProfile = this.userProfileNum;
        //   }
        if (me !== -1) {
          if (me === 6) {
            a = this.leaderboard;
          } else {
            const place = this.leaderboard.findIndex(
              res => res.score == myScore
            );
            const myUser = this.leaderboard.find(
              res => res.id == this.userProfileNum
            );
            a = this.leaderboard.filter(res => res.id !== this.userProfileNum);
            a.splice(place, 0, myUser);
          }
        } else {
          const place = this.leaderboard.findIndex(res => res.score == myScore);
          const myUser = {
            id: this.userProfileNum,
            rank: myRank,
            score: myScore,
            rules_score: this.user.rules_score,
            words_score: this.user.words_score,
            sentences_score: this.user.sentences_score
          };
          a = this.leaderboard;
          a.splice(place, 0, myUser);
          this.userProfile =
            this.leaderboard.find(res => res.score == this.userScore).id || 0;
        }
        const newMe = a.findIndex(res => res.id == this.userProfileNum);
        const startNum = myRank - newMe;
        this.newList = a.map((user, idx) => {
          return { ...user, num: startNum + idx };
        });
        console.log(this.leaderboard);
        console.log(this.newList);
      }
      setTimeout(() => {
        document.documentElement.style.scrollBehavior = "smooth";
        // const topPosition = document.querySelector(".container").scrollIntoView({
        //   behavior: "smooth",
        //   block: "start",
        //   inline: "start"
        // });
        const topPosition = document.querySelector(".divMe");
        window.scroll({
          behavior: "smooth",
          top: topPosition.offsetTop - 250,
          left: 0
        });
      }, 250);
    }
  },
  components: {
    GoogleButton,
    SlinkyVue
  }
};
</script>

<style scoped>
.divMe {
  font-weight: 500;
  background-color: #555fff;
  color: white;
}
.tblMain {
  width: 100%;
}
.rankSqure {
  flex-grow: 1;
  text-align: center;
  width: 25%;
}
.loader {
  text-align: center;
  margin: 30px;
}
.top-users {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 150px);
  margin-bottom: 60px;
  overflow: scroll;
}
.googleBtn {
  width: 100%;
  background-color: #555fff;
  color: white;
  text-align: center;
  height: 60px;
  font-size: 26px;
  /* position: fixed;
  bottom: 58px; */
  z-index: 5;
}
@media (min-width: 780px) {
  .googleBtn {
    width: 60%;
  }
}
.user:last-child {
  margin-bottom: 125px;
}
</style>



// WEBPACK FOOTER //
// LeaderBoard.vue?227971db